import { useEffect } from "react";
import SantaRosaHeroSection from "./components/HeroSection";
import SantaRosaStickyNav from "./components/StickyNav";
import SantaRosaProcessingTimeSection from "./components/ProcessingTimeSection";
import SantaRosaServicesSection from "./components/ServicesSection";
import SantaRosaLocalAreaSection from "./components/LocalAreaSection";
import SantaRosaTravelTimingSection from "./components/TravelTimingSection";
import SantaRosaDestinationsSection from "./components/DestinationsSection";
import SantaRosaTestimonialsSection from "./components/TestimonialsSection";
import SantaRosaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SantaRosaComparisonSection from "./components/ComparisonSection";
import SantaRosaMistakesSection from "./components/MistakesSection";
import SantaRosaHowItWorksSection from "./components/HowItWorksSection";
import SantaRosaFAQSection, { faqs } from "./components/FAQSection";
import SantaRosaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SantaRosaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function SantaRosaPage() {
  useEffect(() => {
    document.title = "Emergency Passport Santa Rosa, CA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/santa-rosa/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Santa Rosa, CA — as fast as 24 hours. Serving all of Sonoma County including Petaluma, Healdsburg, and Oakmont. A+ BBB rated, registered State Dept. courier. Best price guarantee.");
    setMeta("geo.placename", "Santa Rosa, California");
    setMeta("geo.region", "US-CA");
    setMeta("geo.position", "38.4404;-122.7141");
    setMeta("ICBM", "38.4404, -122.7141");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "California", item: "https://fastpassportcenter.com/california/" },
          { "@type": "ListItem", position: 3, name: "Santa Rosa Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Santa Rosa and Sonoma County — as fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Santa Rosa", containedInPlace: { "@type": "State", name: "California" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <SantaRosaHeroSection />
      <SantaRosaStickyNav />
      <SantaRosaProcessingTimeSection />
      <SantaRosaServicesSection />
      <SantaRosaLocalAreaSection />
      <SantaRosaTravelTimingSection />
      <SantaRosaDestinationsSection />
      <SantaRosaTestimonialsSection />
      <SantaRosaAcceptanceFacilitiesSection />
      <SantaRosaComparisonSection />
      <SantaRosaMistakesSection />
      <SantaRosaHowItWorksSection />
      <SantaRosaFAQSection />
      <SantaRosaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/santa-rosa" state="CA" />
      <SantaRosaFinalCTA />
    </div>
  );
}